import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { gameAPI } from '../api/game';
import styles from './SchoolSupplies.module.css';

// ─── صفحه‌ی مستقل «لیست وسایل سال اول» ──────────────────────────────────────
// این برگه از داخل نامه محرمانه لینک می‌شود و داده‌اش را از همان لیستی می‌گیرد
// که پنل ادمین (تب «وسایل مدرسه») مدیریت می‌کند.
// طبق قانون کلی سیستم، قیمت فقط بر اساس پول دنیای جادوگری نمایش داده می‌شود (بدون تومان).

function formatGalleonPrice(item) {
  const g = item.priceGalleons || 0;
  const s = item.priceSickles || 0;
  const k = item.priceKnuts || 0;
  const parts = [];
  if (g > 0) parts.push(`${g} گالیون`);
  if (s > 0) parts.push(`${s} سیکل`);
  if (k > 0) parts.push(`${k} نات`);
  return parts.length > 0 ? parts.join(' و ') : 'رایگان';
}

export default function SchoolSupplies() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') || '';
  const year = parseInt(searchParams.get('year')) || 1;

  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    gameAPI
      .getSchoolSupplies(year)
      .then((res) => {
        if (!mounted) return;
        const d = res.data;
        if (!d.success) throw new Error(d.message);
        setCategories(d.categories || []);
        setStatus('ready');
      })
      .catch((e) => {
        if (!mounted) return;
        setError(e.response?.data?.message || e.message);
        setStatus('error');
      });
    return () => {
      mounted = false;
    };
  }, [year]);

  const backHref = code ? `/secret?code=${code}` : '/secret';

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.logo}>🛒</div>
          <h1 className={styles.title}>لیست وسایل سال {year === 1 ? 'اول' : year}</h1>
          <p className={styles.subtitle}>خرید از کوچه دیاگون — مدرسه علوم و فنون جادوگری هاگوارتز</p>
          <a href={backHref} className={styles.backLink}>← بازگشت به نامه محرمانه</a>
        </div>

        {status === 'loading' && (
          <div className={styles.loadingWrap}>در حال بارگذاری لیست وسایل...</div>
        )}

        {status === 'error' && (
          <div className={styles.errorWrap}>
            <span className={styles.errorMsg}>{error}</span>
          </div>
        )}

        {status === 'ready' && categories.length === 0 && (
          <div className={styles.emptyState}>هنوز وسیله‌ای برای این سال ثبت نشده است.</div>
        )}

        {status === 'ready' && categories.map((cat) => (
          <section key={cat.category} className={styles.categorySection}>
            <h2 className={styles.categoryTitle}>{cat.label}</h2>
            <div className={styles.itemsGrid}>
              {cat.items.map((item) => (
                <div key={item._id} className={styles.itemCard}>
                  {item.isMandatory && <span className={styles.mandatoryBadge}>اجباری</span>}
                  {item.image && (
                    <img src={item.image} alt={item.farsiName || item.name} className={styles.itemImage} />
                  )}
                  <div className={styles.itemName}>{item.farsiName || item.name}</div>
                  {(item.farsiDescription || item.description) && (
                    <div className={styles.itemDesc}>{item.farsiDescription || item.description}</div>
                  )}
                  <div className={styles.itemPrice}>
                    {formatGalleonPrice(item)}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}

        <div className={styles.footer}>
          <p>این وسایل باید پیش از سفر با هاگوارتز اکسپرس تهیه شوند.</p>
        </div>
      </div>
    </div>
  );
}
